import { render, staticRenderFns } from "./TrialExpireRemindHost.vue?vue&type=template&id=587d3690"
import script from "./TrialExpireRemindHost.vue?vue&type=script&lang=js"
export * from "./TrialExpireRemindHost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports